import { createContext, useState } from 'react'

export const FidelityContext = createContext(null)

const filterStatementsEnums = {
  all: 1,
  accumulation: 2,
  redemption: 3,
  expired: 4,
  toReceive: 5,
}

const filterCampaignEnums = {
  'all-campaign': 1,
  'my-campaign': 2,
  'closed-campaign': 3,
  'active-campaign': 4,
}

const tabsEnums = {
  WALLET: 1,
  REDEMPTION: 2,
  STATEMENT: 3,
  CAMPAIGN: 4,
}

const FidelityContextProvider = ({ children }) => {
  const [tab, setTab] = useState(1)
  const [statementFilter, setStatementFilter] = useState(1)
  const [campaignFilter, setCampaignFilter] = useState(1)

  const handleChangeCampaignFilter = (value) => {
    setCampaignFilter(value)
  }

  const handleChangeStatementFilter = (value) => {
    setStatementFilter(value)
  }

  const handleChangeTab = (value) => {
    setTab(value)
  }

  const getCurrentCampaignFilter = () => {
    return campaignFilter
  }

  const getCurrentStatementFilter = () => {
    return statementFilter
  }

  const getCurrentTab = () => {
    return tab
  }

  const value = {
    filterCampaignEnums,
    getCurrentCampaignFilter,
    handleChangeCampaignFilter,
    filterStatementsEnums,
    getCurrentStatementFilter,
    handleChangeStatementFilter,
    tabsEnums,
    getCurrentTab,
    handleChangeTab,
  }

  return (
    <FidelityContext.Provider value={value}>
      {children}
    </FidelityContext.Provider>
  )
}

export default FidelityContextProvider
